var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");

var CustomPadStackData = function (topCopper, hole, innerCopper, bottomCopper, topSolderMask, topSolderPaste, bottomSolderMask) {
    this.makeObservableTreeNode();

    this.topSolderMask = this.value("topSolderMask", true);
    this.topSolderPaste = this.value("topSolderPaste", true);
    this.topCopper = this.value("topCopper", true);
    this.innerCopper = this.value("innerCopper", true);
    this.bottomCopper = this.value("bottomCopper", true);
    this.bottomSolderMask = this.value("bottomSolderMask", true);

    this.hole = this.value("hole", true);

    if(topCopper != undefined) this.topCopper(topCopper);
    if(innerCopper != undefined) this.innerCopper(innerCopper);
    if(bottomCopper != undefined) this.bottomCopper(bottomCopper);
    if(topSolderMask != undefined) this.topSolderMask(topSolderMask);
    if(bottomSolderMask != undefined) this.bottomSolderMask(bottomSolderMask);
    if(topSolderPaste != undefined) this.topSolderPaste(topSolderPaste);
    if(hole != undefined) this.hole(hole);
};
lib_core.mixin(CustomPadStackData, lib_core.ObservableTreeNode);

module.exports = CustomPadStackData;
